import { IAMAPI } from './API'
import Skill from './models/Skill'
import {
  FindSkillsQuery,
  CreateSkillPayload,
  UpdateSkillPayload,
  SkillDTO,
} from './dtos/skill'
import { collection } from 'infra/collection'
import { GetCurrentWorkspace } from './SessionStore'
import { CursorPaged, PrimeProps } from 'types/definitions'

export type PrimeSkill = (
  props: PrimeProps<SkillDTO, 'id'>,
) => Skill | undefined

export default class SkillStore {
  skills = collection<SkillDTO, Skill>({
    create: () => new Skill(),
  })

  constructor(
    private api: IAMAPI,
    private getCurrentWorkspace: GetCurrentWorkspace,
  ) {}

  forWorkspace(workspaceId: string) {
    return this.skills.filter((x) => x.workspaceId === workspaceId)
  }

  async get(id: string) {
    return this.api.skills.get(id).then((data) => this.skills.set(data))
  }

  async find(query: FindSkillsQuery) {
    return this.api.skills
      .find({
        ...query,
        order_by: 'name asc',
      })
      .then((paged) => CursorPaged.map<SkillDTO, Skill>(paged, this.skills.set))
  }

  async create(data: CreateSkillPayload) {
    return this.api.skills
      .create({
        ...data,
      })
      .then((data) => this.skills.set(data))
  }

  async update(id: string, data: UpdateSkillPayload) {
    return this.api.skills
      .update(id, data)
      .then((data) => this.skills.set(data))
  }

  async destroy(id: string) {
    return this.api.skills.delete(id).then(() => this.skills.remove(id))
  }
}
